import {
    Card,
    CardContent,
    CardHeader,
    CardTitle,
    CardDescription,
} from "@shared-frontend/components/ui/card";
import { Skeleton } from "@shared-frontend/components/ui/skeleton";

export function VerifyEmailPageSkeleton() {
    return (
        <div className="min-h-screen flex items-center justify-center p-6 bg-gray-50">
            <Card className="w-full max-w-md">
                <CardHeader className="text-center">
                    <div className="flex justify-center mb-4">
                        <Skeleton className="h-16 w-40" />
                    </div>
                    <Skeleton className="h-8 w-64 mx-auto mb-2" />
                    <Skeleton className="h-4 w-80 mx-auto" />
                </CardHeader>
                <CardContent className="space-y-6">
                    <div className="space-y-4">
                        {/* Password Field Skeleton */}
                        <div className="space-y-2">
                            <Skeleton className="h-4 w-24" />
                            <Skeleton className="h-10 w-full" />
                        </div>

                        {/* Confirm Password Field Skeleton */}
                        <div className="space-y-2">
                            <Skeleton className="h-4 w-32" />
                            <Skeleton className="h-10 w-full" />
                        </div>

                        {/* Password Requirements Skeleton */}
                        <div className="border border-gray-200 rounded-lg p-4 bg-gray-50">
                            <Skeleton className="h-4 w-48 mb-3" />
                            <div className="space-y-2">
                                <div className="flex items-center">
                                    <Skeleton className="h-4 w-4 mr-2" />
                                    <Skeleton className="h-4 w-32" />
                                </div>
                                <div className="flex items-center">
                                    <Skeleton className="h-4 w-4 mr-2" />
                                    <Skeleton className="h-4 w-40" />
                                </div>
                                <div className="ml-6 space-y-1">
                                    <div className="flex items-center">
                                        <Skeleton className="h-3 w-3 mr-2" />
                                        <Skeleton className="h-3 w-36" />
                                    </div>
                                    <div className="flex items-center">
                                        <Skeleton className="h-3 w-3 mr-2" />
                                        <Skeleton className="h-3 w-36" />
                                    </div>
                                    <div className="flex items-center">
                                        <Skeleton className="h-3 w-3 mr-2" />
                                        <Skeleton className="h-3 w-24" />
                                    </div>
                                    <div className="flex items-center">
                                        <Skeleton className="h-3 w-3 mr-2" />
                                        <Skeleton className="h-3 w-40" />
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Button Skeleton */}
                        <Skeleton className="h-10 w-full" />
                    </div>
                </CardContent>
            </Card>
        </div>
    );
}
